import React from "react";
import { useNavigate, useParams } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
// import APIs
import OrderDetailApi from "../../api/customer/order/GetDetail";
import SendToGateWayApi from "../../api/customer/order/SendToGateWay";

//import UIs
import BasketItemCard from "../../ui/cards/BasketItem";

import SpeakerNotesIcon from "@mui/icons-material/SpeakerNotes";

import { FromInt, numberSpace } from "../../helpers/NumberTools";

//import skeletons
import AddressCardSkeleton from "../../ui/skeletons/AddressCard";

import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneAndroidIcon from "@mui/icons-material/PhoneAndroid";
import PhoneIcon from "@mui/icons-material/Phone";
import ApprovalIcon from "@mui/icons-material/Approval";
import PersonIcon from "@mui/icons-material/Person";

import { ErrorNotify } from "../../ui/Toast";
import { setIsLoading, setMetaData } from "../../redux/reducers/page";
const ViewOrder = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [sending, setSending] = React.useState(false);

  const [isLoaded, setIsLoaded] = React.useState(false);
  const [order, setOrder] = React.useState([]);

  // redux
  const dispatch = useDispatch();
  const { auth } = useSelector((state) => state.customerAuth);

  // find ViewOrder order
  const findOrder = async () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });

    setIsLoaded(false);
    const OrderResult = await OrderDetailApi(auth.token, id);
    if (OrderResult.status === 404) {
      ErrorNotify("سفارش وجود ندارد");
      navigate(`/`);
      return;
    }
    if (OrderResult.status !== 200) {
      ErrorNotify(JSON.parse(OrderResult.response).error);
      return;
    }
    setOrder(OrderResult.data);
    setIsLoaded(true);
  };
  const sendToGateWay = async () => {
    // setIsLoaded(false);
    const result = await SendToGateWayApi(auth.token, id, "omid");

    if (result.status !== 200) {
      ErrorNotify(JSON.parse(result.response).error);
      return;
    }
    if (result.data.method === "GET") {
      window.location.href = result.data.redirectUrl;
      return;
    }
    const form = document.createElement("form");
    form.method = "POST";
    form.action = result.data.redirectUrl;

    const input1 = document.createElement("input");
    input1.type = "hidden";
    input1.name = "token";
    input1.value = result.data.token;
    form.appendChild(input1);

    const input2 = document.createElement("input");
    input2.type = "hidden";
    input2.name = "language";
    input2.value = "fa";
    form.appendChild(input2);

    document.body.appendChild(form);
    form.submit();
  };
  React.useEffect(() => {
    dispatch(
      setMetaData({
        title: "میشرت :  سفارش",
        description: "میشرت:  سفارش",
      })
    );
    dispatch(setIsLoading(false));
    findOrder();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="col-12 col-md-10  col-lg-9 col-xl-8  justify-content-center">
      <div className="row justify-content-center p-3 p-md-1 mb-5 pb-5">
        {isLoaded ? (
          <>
            {order.Basket.BasketItems.map((basketItem, index) => {
              return (
                <BasketItemCard
                  isOrder={true}
                  key={index}
                  basketItem={basketItem}
                />
              );
            })}
            {order.status === "payPending" ? (
              <div className="row mt-4 p-0">
                {!sending ? (
                  <span
                    onClick={() => {
                      sendToGateWay();
                      setSending(true);
                    }}
                    className="btn btn-primary w-100 d-flex justify-content-between align-items-center"
                  >
                    تکمیل خرید
                    <span className="badge badge-warning position-relative sabad_card-totalprice">
                      {FromInt(numberSpace(`${order.price}`))} تومان{" "}
                    </span>
                  </span>
                ) : (
                  <span
                    style={{ cursor: "wait" }}
                    className="btn btn-secondary w-100 d-flex justify-content-between align-items-center"
                  >
                    در حال هدایت به درگاه پرداخت
                    <span className="badge badge-warning position-relative sabad_card-totalprice">
                      {FromInt(numberSpace(`${order.price}`))} تومان{" "}
                    </span>
                  </span>
                )}
              </div>
            ) : (
              <>
                {order.status === "newOrder" || order.status === "pending" ? (
                  <div className="row mt-4 p-0">
                    <span className="btn btn-success w-100 d-flex justify-content-between align-items-center">
                      پرداخت شده، در حال بررسی
                      <span className="badge badge-warning position-relative sabad_card-totalprice">
                        {FromInt(numberSpace(`${order.price}`))} تومان{" "}
                      </span>
                    </span>
                  </div>
                ) : (
                  <>
                    <div className="row mt-4 p-0">
                      <span className="btn btn-success w-100 d-flex justify-content-between align-items-center">
                        {order.statusTxt}
                        <span className="badge badge-warning position-relative sabad_card-totalprice">
                          {FromInt(numberSpace(`${order.price}`))} تومان{" "}
                        </span>
                      </span>
                    </div>
                    <div className="row cards">
                      <div className="col-12">
                        <PersonIcon className="m-1" />{" "}
                        {FromInt(`${order.recipientsName}`)}
                      </div>
                      <div className="col-12 ">
                        <LocationOnIcon className="m-1" />{" "}
                        {FromInt(
                          `${order.CustomerAddress.Province.name} - ${order.CustomerAddress.City} - ${order.CustomerAddress.recipientsAddress}`
                        )}
                      </div>
                      <div className="col-12 ">
                        <ApprovalIcon className="m-1" />{" "}
                        {FromInt(`${order.CustomerAddress.postalCode}`)}
                      </div>
                      <div className="col-12 ">
                        <PhoneAndroidIcon className="m-1" />{" "}
                        {FromInt(`${order.recipientsMobiles}`)}
                      </div>
                      <div className="col-12  ">
                        <PhoneIcon className="m-1" />{" "}
                        {FromInt(`${order.recipientsPhone}`)}
                      </div>
                    </div>
                    {order.OrderHistories.map((item, index) => {
                      return (
                        <div className="row cards" key={index}>
                          <div className="col-md-3 col-12">
                            <div
                              className="row justify-content-center"
                              dir="ltr"
                            >
                              {item.Media ? (
                                <img
                                  src={item.Media.mediaUrl}
                                  alt={item.statusTxt}
                                />
                              ) : null}
                            </div>
                          </div>
                          <div className="col-md-9 col-12 ">
                            <div className="col-12 ">
                              <SpeakerNotesIcon className="m-1" />{" "}
                              {FromInt(`${item.description}`)}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </>
                )}
              </>
            )}
          </>
        ) : (
          <AddressCardSkeleton />
        )}
      </div>
    </div>
  );
};

export default ViewOrder;
